import React from 'react';
import { Heading03, BodyCopy } from '@uds/typography';
import { ShortcodeProps } from 'presentation/components/Shortcode';

import getClassNames from './ItemDetails.stylesheet';

interface OuterProps {
  hBaseline: number;
  title: ShortcodeProps | string;
  text: ShortcodeProps | string;
}

const PureSalesboardItemDetails = ({ hBaseline, title, text }: OuterProps) => {
  const classNames = getClassNames();
  return (
    <div>
      <Heading03 depth={hBaseline} className={classNames.title}>
        <>{title}</>
      </Heading03>
      <BodyCopy className={classNames.text}>
        <>{text}</>
      </BodyCopy>
    </div>
  );
};

PureSalesboardItemDetails.displayName = 'SalesboardItemDetails';

export default PureSalesboardItemDetails;
